// the *+ hidden search is sth i introduced for the elastique website

import { SearchView, SuggestView } from './search_view'
import load_html5_videos_controller from '../html5video/load_html5_videos_controller'
import history_controller from '../history/history_controller_new'
import debounce from 'lodash/debounce'
// Why i use a deferred object:
// When the search endpoint hasn't loaded yet and fuseInitialized is still false, the user can already input their search term
// However, because the data that can be searched through wasn't loaded yet, this will cause an error
// That is why I defer the searching through the data by using a deferred obj
// Function "searchIfEndpointLoaded" is related to this
var $deferred = jQuery.Deferred()

var fuseInitialized = false
var fuse
var posts
var valueToLowerCase
var searchView
// amount of suggested items — configurable via Lay Options → Search → "Maximum autosuggest results"
var autoCompleteAmount = layData.search_autocomplete_amount && layData.search_autocomplete_amount > 0 ? layData.search_autocomplete_amount : 3
// When "Search in Gridder text elements" is on, the thumbnail results no
// longer update on every keystroke. The user types → autosuggest updates
// live → Enter triggers the heavy server-side search.
var gridderContentMode = !!layData.search_in_gridder_content
var fuseOptions = {
	shouldSort: true,
	threshold: 0.3,
	keys: [
		'title',
		'descr',
		'cats',
		'tags'
		// Custom taxonomies will be added dynamically
	],
}

// Initialize Fuse.js with dynamic taxonomy keys
var initializeFuse = function(results) {
	// Add custom taxonomy keys to fuseOptions
	var customTaxonomyKeys = layData.custom_taxonomies.map(taxonomy => 'custom_taxonomies.' + taxonomy);
	fuseOptions.keys = fuseOptions.keys.concat(customTaxonomyKeys);
	fuse = new Fuse(results, fuseOptions);
	fuseInitialized = true;
	$deferred.resolve();
}

var loadSearchableData = function () {
	if (!fuseInitialized) {
		var url = layData.wpapiroot + 'laytheme/search/'
		// Pass the current Polylang language so the REST endpoint, which
		// is itself language-agnostic, can scope results to whatever
		// language the user is browsing in.
		if (layData.search_current_language) {
			url += (url.indexOf('?') === -1 ? '?' : '&') + 'lang=' + encodeURIComponent(layData.search_current_language)
		}
		jQuery.ajax({
			url: url,
			success: function (results) {
				initializeFuse(results);
			},
		})
	}
}

// if deferred is resolved, go and search. If deferred is still waiting to resolve, search once it as resolved
var searchIfEndpointLoaded = function () {
	if ($deferred.state() == 'resolved') {
		search()
	} else {
		jQuery.when($deferred).then(function () {
			search()
		})
	}
}

var search = debounce(function () {
	var value = jQuery('#search-query').val()
	valueToLowerCase = value.toLowerCase()
	if (value.length == 0) {
		jQuery('#search-autosuggest-list').html('')
		jQuery('#search-results-region').html('')
		return
	}

	// Handle special *+ search for hidden cases (only if enabled)
	var isHiddenSearch = value.startsWith('*+')
	var searchValue = isHiddenSearch ? value.substring(2) : value
	
	// Only apply hidden case logic if the feature is enabled
	if (layData.search_hidden_projects_enabled) {
		// If it's a hidden search, filter posts to ONLY include hidden cases
		if (isHiddenSearch) {
			posts = fuse.search(searchValue)
			posts = posts.filter(function(post) {
				return post && post.hasOwnProperty('hidden_project') && post.hidden_project == "1"
			})
			// remove categories and tags
			posts = posts.map(function(post) {
				post.cats = []
				post.custom_taxonomies = []
				post.tags = []
				return post
			})
		} else {
			// Regular search - exclude hidden cases from autocomplete
			posts = fuse.search(searchValue)
			// Filter out hidden cases from regular search results
			posts = posts.filter(function(post) {
				if(post.hasOwnProperty('hidden_project')){
					return post && post.hidden_project != "1"
				} else {
					return true
				}
			})
		}
	} else {
		// Hidden cases feature disabled - use regular search
		posts = fuse.search(searchValue)
	}

	if (posts.length > 0) {
		searchView.addClassForNoResults()
	}

	// In gridderContentMode the thumbnail results don't refresh on every
	// keystroke — they wait for Enter, which kicks off the heavy server-side
	// search across Gridder JSON. Only the autosuggest updates live here.
	if (!gridderContentMode) {
		renderThumbnailResultsFromPosts(posts, value)
	}

	if (layData.search_autosuggest_hide == false) {
		suggest()
	}
}, 200)

var renderThumbnailResultsFromPosts = function (postsArray, query) {
	var only_post_ids = get_only_postids(postsArray)
	renderThumbnailResultsFromIds(only_post_ids, query)
}

// Held so a still-in-flight request from a previous keystroke can be
// aborted when a new render is fired. Without this, when the user types
// fast and / or clicks an autosuggest item before the previous AJAX has
// returned, the older response can land AFTER the newer one and
// overwrite the up-to-date result HTML with stale data — visible to the
// user as "I clicked the suggestion and got nothing / wrong results".
var thumbnailResultsXhr = null
var renderThumbnailResultsFromIds = function (idsArray, query) {
	var ajax_data = {
		action: 'get_search_result',
		found_posts: JSON.stringify(idsArray),
		// Pass the user's query so the server can extract Google-style
		// snippets for the page-result list (pages have no thumbnail).
		query: query || jQuery('#search-query').val() || '',
	}
	if (thumbnailResultsXhr && thumbnailResultsXhr.readyState !== 4) {
		thumbnailResultsXhr.abort()
	}
	thumbnailResultsXhr = jQuery.ajax({
		url: layData.ajax_url,
		data: ajax_data,
		type: 'post',
		success: function (resultMarkup) {
			jQuery('#search-results-region').html(resultMarkup)
			setTimeout(function () {
				window.laytheme.emit('searchresultshown')
			}, 0)
		},
		error: function () {},
	})
}

// Write the current search query into the URL so the page can be shared /
// bookmarked. Triggered on Enter (the "commit" moment). Routes through
// history_controller because Lay's history layer overrides the native
// `window.history.replaceState` and blocks direct calls (to keep Vimeo /
// YouTube iframes from polluting the back-button stack). Calling the
// native API directly here would no-op silently.
var URL_PARAM_NAME = 'lay-search'
var updateUrlWithQuery = function (value) {
	history_controller.updateUrlSearchParam(URL_PARAM_NAME, value)
}

var readQueryFromUrl = function () {
	try {
		var url = new URL(window.location.href)
		return url.searchParams.get(URL_PARAM_NAME) || ''
	} catch (e) {
		return ''
	}
}

// Enter-triggered full-content search across Gridder JSON. Only used when
// "Search in Gridder text elements" is enabled. Adds a loading class to
// the search input region so the CSS can render a spinner during the
// roundtrip.
var fullContentXhr = null
var runFullContentSearch = function () {
	var value = jQuery('#search-query').val()
	// Autosuggest list goes away on Enter — we've committed to a query.
	jQuery('#search-autosuggest-list').html('')
	if (!value || value.length < 2) {
		jQuery('#search-results-region').html('')
		return
	}
	if (fullContentXhr && fullContentXhr.readyState !== 4) {
		fullContentXhr.abort()
	}
	jQuery('#search-region').addClass('lay-search-loading')
	fullContentXhr = jQuery.ajax({
		url: layData.ajax_url,
		type: 'post',
		data: {
			action: 'lay_search_full_content',
			query: value,
			lang: layData.search_current_language || '',
		},
		success: function (resp) {
			jQuery('#search-region').removeClass('lay-search-loading')
			var ids = (resp && resp.success && resp.data && Array.isArray(resp.data.post_ids)) ? resp.data.post_ids : []
			if (ids.length === 0) {
				jQuery('#search-results-region').html('')
				return
			}
			renderThumbnailResultsFromIds(ids, value)
		},
		error: function (jqXHR, textStatus) {
			if (textStatus === 'abort') return
			jQuery('#search-region').removeClass('lay-search-loading')
		},
	})
}

var suggest = function () {
	// autocomplete
	var autoCompleteArray = []
	var isHiddenSearch = valueToLowerCase.startsWith('*+')
	var searchValue = isHiddenSearch ? valueToLowerCase.substring(2) : valueToLowerCase
	
	// search for items that starts with the string
	for (var post of posts) {
		var postData = post
		
		// Only apply hidden case logic if the feature is enabled
		if (layData.search_hidden_projects_enabled == '1') {
			// For hidden search, only suggest from hidden cases
			if (isHiddenSearch && (!postData.hidden_project || postData.hidden_project != "1")) {
				continue
			}
			// For regular search, exclude hidden cases from autocomplete
			if (!isHiddenSearch && postData.hidden_project == "1") {
				continue
			}
		}
		
		if (post.title.toLowerCase().startsWith(searchValue) && autoCompleteArray.indexOf(post.title) == -1) {
			autoCompleteArray.push(post.title)
		}
		if (post.descr.toLowerCase().startsWith(searchValue) && autoCompleteArray.indexOf(post.descr) == -1) {
			autoCompleteArray.push(post.descr)
		}
		for (var i = 0; i < post.cats.length; i++) {
			var cat = post.cats[i]
			if (cat.toLowerCase().startsWith(searchValue) && autoCompleteArray.indexOf(cat) == -1) {
				autoCompleteArray.push(cat)
			}
		}
		for (var i = 0; i < post.tags.length; i++) {
			var tag = post.tags[i]
			if (tag.toLowerCase().startsWith(searchValue) && autoCompleteArray.indexOf(tag) == -1) {
				autoCompleteArray.push(tag)
			}
		}
		// Search through custom taxonomies
		if (post.custom_taxonomies) {
			Object.entries(post.custom_taxonomies).forEach(([taxonomy, terms]) => {
				if (Array.isArray(terms)) {
					terms.forEach(term => {
						// Decode HTML entities in terms (like &amp;)
						const decodedTerm = term.replace(/&amp;/g, '&').replace(/&ndash;/g, '–');
						if (decodedTerm.toLowerCase().startsWith(searchValue) && autoCompleteArray.indexOf(decodedTerm) == -1) {
							autoCompleteArray.push(decodedTerm)
						}
					})
				}
			})
		}

		if (autoCompleteArray.length > autoCompleteAmount) {
			break
		}
	}
	// remove first suggest if it is equal to input
	if (autoCompleteArray.length != 0 && searchValue == autoCompleteArray[0].toLowerCase()) {
		autoCompleteArray.splice(0, 1)
	}

	// what is this for? ah its for filling in the rest when first suggest was removed if its equal to input
	if (autoCompleteArray.length == 0) {
		for (var post of posts) {
			// Get the actual post data (handle both direct posts and fuse search results)
			var postData = post
			
			// Only apply hidden case logic if the feature is enabled
			if (layData.search_hidden_projects_enabled == '1') {
				// For hidden search, only suggest from hidden cases
				if (isHiddenSearch && (!postData.hidden_project || postData.hidden_project != "1")) {
					continue
				}
				// For regular search, exclude hidden cases from autocomplete
				if (!isHiddenSearch && postData.hidden_project == "1") {
					continue
				}
			}
			
			if (postData.title.toLowerCase().indexOf(searchValue) !== -1 && autoCompleteArray.indexOf(postData.title) == -1) {
				autoCompleteArray.push(postData.title)
			}
			if (postData.descr.toLowerCase().indexOf(searchValue) !== -1 && autoCompleteArray.indexOf(postData.descr) == -1) {
				autoCompleteArray.push(postData.descr)
			}
			for (var i = 0; i < postData.cats.length; i++) {
				var cat = postData.cats[i]
				if (cat.toLowerCase().startsWith(searchValue) && autoCompleteArray.indexOf(cat) == -1) {
					autoCompleteArray.push(cat)
				}
			}
			for (var i = 0; i < postData.tags.length; i++) {
				var tag = postData.tags[i]
				if (tag.toLowerCase().startsWith(searchValue) && autoCompleteArray.indexOf(tag) == -1) {
					autoCompleteArray.push(tag)
				}
			}
			// Search through custom taxonomies for partial matches
			if (postData.custom_taxonomies) {
				Object.entries(postData.custom_taxonomies).forEach(([taxonomy, terms]) => {
					if (Array.isArray(terms)) {
						terms.forEach(term => {
							// Decode HTML entities in terms (like &amp;)
							const decodedTerm = term.replace(/&amp;/g, '&').replace(/&ndash;/g, '–');
							if (decodedTerm.toLowerCase().indexOf(searchValue) !== -1 && autoCompleteArray.indexOf(decodedTerm) == -1) {
								autoCompleteArray.push(decodedTerm)
							}
						})
					}
				})
			}

			if (autoCompleteArray.length > autoCompleteAmount) {
				break
			}
		}
	}

	// remove first suggest if it is equal to input
	if (autoCompleteArray.length != 0 && searchValue == autoCompleteArray[0].toLowerCase()) {
		autoCompleteArray.splice(0, 1)
	}

	if (posts.length != 0) {
		var markup = '<div class="suggest-collection" id="suggest-results">'
		autoCompleteArray.slice(0, autoCompleteAmount).map((suggest) => {
			if(isHiddenSearch && suggest != ''){
				suggest = '*+' + suggest
			}
			var suggestView = new SuggestView(suggest)
			markup += suggestView.getMarkup()
		})
		markup += '</div>'
		jQuery('#search-autosuggest-list').html(markup)
	} else {
		jQuery('#search-autosuggest-list').html('')
	}
}

var bindClickSuggestItem = function () {
	jQuery(document).on('click', '.suggest-item', function (e) {
		var autoComplete = jQuery(this).find('.suggest').text()
		jQuery('#search-query').val(autoComplete)
		setTimeout(function () {
			jQuery('#search-autosuggest-list').html('')
			// Treat the click like pressing Enter — commit the URL so the
			// search is shareable, and in gridderContentMode also kick off
			// the server-side full-content search (otherwise the user
			// would have to additionally press Enter just to populate the
			// results region).
			if (typeof search.cancel === 'function') {
				search.cancel()
			}
			updateUrlWithQuery(autoComplete)
			if (gridderContentMode) {
				runFullContentSearch()
			} else {
				// Non-gridder mode: live search populates results +
				// autosuggest from the new query.
				searchView.onInput()
			}
		}, 0)
	})
}

var bindSearchOpen = function () {
	jQuery(document).on('click', '[href="#search"]', function (e) {
		loadSearchableData()
		e.preventDefault()
		e.stopPropagation()
		searchView.onShow()
		window.laytheme.emit('searchshown')
	})
}

var bindSearchResultNavigation = function () {
	document.addEventListener(
		'click',
		function (event) {
			if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
				return
			}
			var target = event.target
			if (!target || typeof target.closest != 'function') {
				return
			}
			var link = target.closest('#search-results-region a[data-type][href]:not([target="_blank"])')
			if (!link || typeof history_controller.skipNextTransitionOut != 'function') {
				return
			}
			if (jQuery('body').attr('data-type') == link.getAttribute('data-type') && jQuery('body').attr('data-id') == link.getAttribute('data-id')) {
				event.preventDefault()
				event.stopPropagation()
				searchView.onHide()
				return
			}
			history_controller.skipNextTransitionOut()
		},
		true
	)
}

var initView = function () {
	searchView = new SearchView()
}

var bindEscapeKey = function () {
	jQuery(document).keyup(function (e) {
		if (e.which == 27) {
			searchView.onHide()
		}
	})
}

// Enter on the search input is the "commit" moment:
//   - autosuggest list goes away (user already chose a query)
//   - URL is updated with `?lay-search=...` so the page is shareable /
//     bookmarkable; opening that URL re-opens the overlay with the query
//   - in gridderContentMode the heavy server-side search fires now (the
//     live keystroke flow only updates autosuggest in that mode)
//
// The debounced live `search()` is cancelled here so a pending fire (that
// the user out-raced by pressing Enter) doesn't repopulate the autosuggest
// list after we just cleared it.
var bindEnterKey = function () {
	jQuery(document).on('keydown', '#search-query', function (e) {
		if (e.which !== 13) return
		e.preventDefault()
		if (typeof search.cancel === 'function') {
			search.cancel()
		}
		var value = jQuery('#search-query').val()
		jQuery('#search-autosuggest-list').html('')
		updateUrlWithQuery(value)
		if (gridderContentMode) {
			runFullContentSearch()
		}
	})
}

var get_only_postids = function (posts) {
	var result = []
	for (var i = 0; i < posts.length; i++) {
		var id = posts[i]['postid']
		result.push(id)
	}
	return result
}

var bindCustomizerShowHideEvents = function () {
	window.laytheme.on('customizer_showsearch', function () {
		loadSearchableData()
		searchView.onShow()
	})

	window.laytheme.on('customizer_hidesearch', function () {
		searchView.onHide()
	})

	window.laytheme.on('newpageshown', function () {
		searchView.onHide()
	})
}

var initLoadVideo = function () {
	window.laytheme.on('searchresultshown', function () {
		load_html5_videos_controller.loadVideosInstantly(jQuery('#search-results-region'))
	})
}

// When the overlay closes via X / Escape / programmatic onHide, drop the
// shareable `?lay-search=...` param from the URL so the user doesn't see
// stale state in the address bar after closing. Clicking an actual
// search result navigates away and the param disappears with the
// navigation — this handler covers the close-without-navigation paths.
var bindClearUrlOnHide = function () {
	window.laytheme.on('searchhidden', function () {
		updateUrlWithQuery('')
	})
}

// If the page was loaded with `?lay-search=…` (a shared / bookmarked
// search URL), open the search overlay automatically, fill the input
// with the query and run the same search the user would get by typing
// it + pressing Enter.
//
// Must defer the actual open until AFTER the first `newpageshown` event
// because bindCustomizerShowHideEvents() also subscribes to that event
// and unconditionally calls `searchView.onHide()` — so opening the
// search inside `i()` (which runs before newpageshown fires) would get
// immediately closed again on the very next event tick.
var openSearchFromUrlIfPresent = function () {
	var initialQuery = readQueryFromUrl()
	if (!initialQuery) return

	var opened = false
	var doOpen = function () {
		if (opened) return
		opened = true
		loadSearchableData()
		searchView.onShow()
		window.laytheme.emit('searchshown')
		jQuery('#search-query').val(initialQuery)
		// Defer until the REST endpoint that backs the autosuggest has
		// resolved. searchIfEndpointLoaded() waits on the deferred for us.
		if (gridderContentMode) {
			runFullContentSearch()
		} else {
			searchIfEndpointLoaded()
		}
	}

	// Open after the first newpageshown — by then the hide-on-newpageshown
	// listener has already fired and done its no-op (search wasn't open).
	var firstNewPageShown = true
	window.laytheme.on('newpageshown', function () {
		if (!firstNewPageShown) return
		firstNewPageShown = false
		// setTimeout(…, 0) so we run after any other newpageshown listeners
		// in the queue (including the one that calls onHide).
		setTimeout(doOpen, 0)
	})

	// Safety net: if newpageshown somehow never fires (rare edge case on
	// non-AJAX page loads), open after 1.5s anyway.
	setTimeout(doOpen, 1500)
}

var search_controller = {
	i: function () {
		bindSearchOpen()
		bindSearchResultNavigation()
		bindClickSuggestItem()
		initView()
		bindEscapeKey()
		bindEnterKey()
		bindCustomizerShowHideEvents()
		initLoadVideo()
		bindClearUrlOnHide()
		openSearchFromUrlIfPresent()
	},
	search: function () {
		searchIfEndpointLoaded()
	},
}

export default search_controller
